import { render, staticRenderFns } from "./dialogPrezzi.vue?vue&type=template&id=29a5b9dc"
import script from "./dialogPrezzi.vue?vue&type=script&lang=js"
export * from "./dialogPrezzi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports